export default class ReadMore {
  constructor() {
    this.characterLimit = 170;
    this.readMoreText = 'read more';
    this.readLessText = 'read less';
    this.dataReadSelector = '[data-read]';
  }

  /**
   * Gets a string and add it a read more and read less link text.
   * @param {string} hiddenText with the text needed to be access with read more link. 
   */
  getReadMoreHtml(hiddenText) {
    const hiddenTextArea = `<span class='second-section'>${hiddenText}</span>`;
    const readMore = `<span class='ellipsis'>...</span><span class='read-more' data-read>${this.readMoreText}</span>`;
    const readLess = `<span class='read-less' data-read>${this.readLessText}</span>`;

    return `${hiddenTextArea}${readMore}${readLess}`;
  }

  /**
   * Toggle a class depending if the read more link is clicked showing all the text and
   * hidding the text when read less link is clicked.
   * @param {event} event click dispatch when click on read more or read less text.
   */
  static toggleReadMore(event) {
    const target = event.target;
    const closestReadMore = target.closest('.add-read-more');
    if (closestReadMore.classList.contains('show-less-content')) {
      closestReadMore.classList.remove('show-less-content');
      closestReadMore.classList.add('show-more-content');
      return;
    }

    closestReadMore.classList.add('show-less-content');
    closestReadMore.classList.remove('show-more-content');
  }

  /**
   * Shows the visible text and add the read more link when the string lenght is greater than
   * specified limit characters.
   * @param {DOMElement} textElement is the element where the read more or read less toggle would be apply.
   */
  addReadMoreToggle(textElement) {
    const text = textElement?.innerText;
    if (!textElement || text?.length <= this.characterLimit) {
      return;
    }

    textElement.classList.add('add-read-more', 'show-less-content');
    const visibleText = text.substring(0, this.characterLimit);
    const hiddenText = text.substring(this.characterLimit, text.length);
    const readMoreHtml = this.getReadMoreHtml(hiddenText);
    textElement.innerHTML = `${visibleText}${readMoreHtml}`;

    const readMoreSpans = document.querySelectorAll(this.dataReadSelector);
    readMoreSpans.forEach((element) => element.addEventListener('click', ReadMore.toggleReadMore));
  }
}